if not App.angularApp?
    return

App.angularApp.directive 'mfMaxLength', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>

            max_length = parseInt(attrs.mfMaxLength)

            ngModel.$validators.mfMaxLength = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if String(viewValue).length <= max_length
                    return true

                return false
    }
